import { Typography } from 'antd'
import React from 'react'

import pricing1 from '../../../images/icon-pricing1.png'
import pricing2 from '../../../images/icon-pricing2.png'
import pricing3 from '../../../images/icon-pricing3.png'
import iconYoutube from '../../../images/yt_icon_rgb.png'
import iconLinkeding from '../../../images/LI-In-Bug.png'
import backgroundLogin from '../../../images/backgroundLogin.png'

const { Text } = Typography
const PlansViewFR = () => {
    /*     const downloadPDF = () => {
            const rutaPDF = 'https://firebasestorage.googleapis.com/v0/b/jobmatch-e66b9.appspot.com/o/PDF%2FLesServicesCareerSwipe2023.pdf?alt=media&token=049a5ff4-df0a-4d9f-a8b9-4260a1017803&_gl=1*3nfp6f*_ga*MjAyMDg3OTc5Mi4xNjM1NzEwMzQw*_ga_CW55HF8NVT*MTY5OTQ2MTI0MC4xNi4xLjE.*';
    
            // Realiza una solicitud para obtener el archivo PDF
            fetch(rutaPDF)
                .then((response) => response.blob())
                .then((blob) => {
                    // Crea una URL a partir del Blob
                    const url = URL.createObjectURL(blob);
    
                    // Crea un enlace oculto y dispara un clic para descargar el archivo
                    const enlace = document.createElement('a');
                    enlace.href = url;
                    enlace.target = '_blank';
                    enlace.download = 'Les Services Career Swipe 2023.pdf';
                    enlace.style.display = 'none';
                    document.body.appendChild(enlace);
                    enlace.click();
                    document.body.removeChild(enlace);
                });
        }; */
    return (
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", position: "relative" }}>
            <img className='containerImg' style={{ height: "95vh" }} src={backgroundLogin} alt={backgroundLogin} />
            <div style={{ zIndex: 0, position: "absolute", justifyContent: "center", display: "flex", flexDirection: "column", width: "70%", height: "87%", marginTop: "2%", }}>
                <div style={{ width: "100%", height: "75%", flexDirection: "row", display: "flex", justifyContent: "center", alignItems: "flex-end" }}>
                    <div style={{ width: "33%", height: "90%", position: "relative", backgroundColor: "#2c2c5c", border: "0.4vh solid #363663", borderTopLeftRadius: "2vh", borderTopRightRadius: "2vh", alignItems: "center", display: "flex", flexDirection: "column", paddingTop: "10vh", }}>
                        <img style={{ width: "10vw", position: "absolute", top: "-5vh", }} src={pricing1} alt={pricing1} />
                        <Text style={{ fontSize: "3vh", color: "white" }}>Flux de Carrière</Text>
                        <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "center" }}>
                            <Text style={{ fontSize: "2vh", color: "white", marginTop: "1.5vh" }}>$</Text>
                            <Text style={{ fontSize: "5vh", color: "white", fontWeight: "bold" }}>150</Text>
                        </div>
                        <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "center", position: "relative" }}>
                            <div style={{ width: "85%", height: "100%", marginLeft: "-16.5%", position: "absolute", zIndex: 1, backgroundColor: "#7067ae", top: 0, borderTopRightRadius: "1vh", borderBottomRightRadius: "1vh" }}></div>
                            <Text style={{ fontSize: "2vh", color: "black", fontWeight: "bold", width: "100%", textAlign: "center", zIndex: 2 }} >Par Match</Text>
                        </div>
                        <Text className='textPricing4' >Position optimale</Text>
                        <Text className='textPricing4' >Candidatures spontanées</Text>
                        <Text className='textPricing4' >Matching Automatisé</Text>
                        <Text className='textPricing4' >Tableau de bord</Text>
                    </div>


                    <div style={{ width: "33%", height: "100%", backgroundColor: "#c9c9c9", border: "0.0vh solid #c9c9c9", borderTopLeftRadius: "2vh", borderTopRightRadius: "2vh" }}>
                        <div style={{ width: "100%", height: "100%", paddingTop: "10vh", position: "relative", backgroundColor: "#2c2c5c", border: "0.4vh solid #363663", borderTopLeftRadius: "2vh", borderTopRightRadius: "2vh", marginTop: "1vh%", alignItems: "center", display: "flex", flexDirection: "column" }}>
                            <img style={{ width: "10vw", position: "absolute", top: "-5vh" }} src={pricing2} alt={pricing2} />
                            <Text style={{ fontSize: "3vh", color: "white" }}>Flux de Carrière</Text>
                            <Text style={{ fontSize: "3vh", color: "white", marginTop: "-0.5vh" }}>+Recherche IA</Text>
                            <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "center" }}>
                                <Text style={{ fontSize: "2vh", color: "white", marginTop: "1.5vh" }}>$</Text>
                                <Text style={{ fontSize: "5vh", color: "white", fontWeight: "bold" }}>800</Text>
                            </div>
                            <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "center", position: "relative" }}>
                                <div style={{ width: "85%", height: "100%", marginLeft: "-16.5%", position: "absolute", zIndex: 1, backgroundColor: "#7067ae", top: 0, borderTopRightRadius: "1vh", borderBottomRightRadius: "1vh" }}></div>
                                <Text style={{ fontSize: "2vh", color: "black", fontWeight: "bold", width: "100%", textAlign: "center", zIndex: 2 }} >Par Job</Text>
                            </div>
                            <Text className='textPricing4'>Position dynamique</Text>
                            <Text className='textPricing4' >100 candidatures sollicitées</Text>
                            <Text className='textPricing4' >Matching IA Avancée</Text>
                            <Text className='textPricing4' >Tableau de bord</Text>
                            <Text className='textPricing4' >Information temps réel</Text>
                        </div>
                    </div>



                    <div style={{ width: "33%", height: "90%", position: "relative", backgroundColor: "#2c2c5c", border: "0.4vh solid #363663", borderTopLeftRadius: "2vh", borderTopRightRadius: "2vh", alignItems: "center", display: "flex", flexDirection: "column", paddingTop: "10vh", }}>

                        <img style={{ width: "10vw", position: "absolute", top: "-5vh" }} src={pricing3} alt={pricing3} />
                        <Text style={{ fontSize: "3vh", color: "white" }}>Premium</Text>

                        <Text style={{ fontSize: "4vh", color: "white", fontWeight: "bold" }}>Contacter Ventes</Text>


                        <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "center", position: "relative" }}>
                            <div style={{ width: "85%", height: "100%", marginLeft: "-16.5%", position: "absolute", zIndex: 1, backgroundColor: "#7067ae", top: 0, borderTopRightRadius: "1vh", borderBottomRightRadius: "1vh" }}></div>
                            <Text style={{ fontSize: "2vh", color: "black", fontWeight: "bold", width: "100%", textAlign: "center", zIndex: 2 }} >Solution Entreprise</Text>
                        </div>
                        <Text className='textPricing4' >Position Stratégique</Text>
                        <Text className='textPricing4' >Candidatures illimitées</Text>
                        <Text className='textPricing4' >Recherchiste dédié</Text>
                        <Text className='textPricing4' >Tableau de bord Premium</Text>
                        <Text className='textPricing4' >Information temps réel</Text>
                        <Text className='textPricing4' >Sondage Salarial</Text>
                    </div>




                </div>
                {/* <div onClick={() => window.open('https://gocareerswipe.com/home-fr/', '_blank')} style={{ width: "99%", position: "relative", height: "15%", backgroundColor: "#f39406", marginLeft: "0.5%", borderBottomLeftRadius: "5vh", borderBottomRightRadius: "5vh", justifyContent: "center", display: "flex", alignItems: "center", }}>
                    <Text style={{ fontSize: "4vh", color: "blue", cursor: "pointer", textDecoration: "underline", }}>gocareerswipe.com</Text>
                    <img onClick={() => window.open('https://www.youtube.com/watch?v=vWZ_ME5YrwQ&ab_channel=CareerSwipe', '_blank')} style={{ height: "4vh", marginLeft: 10, position: "absolute", top: "40%", right: "10%" }} src={iconYoutube} alt={iconYoutube} />
                    <img onClick={() => window.open('https://www.linkedin.com/company/services-career-swipe/?viewAsMember=true', '_blank')} style={{ height: "4vh", marginLeft: 10, position: "absolute", top: "40%", right: "15%" }} src={iconLinkeding} alt={iconYoutube} />
                </div>
                 */}
                <div
                    style={{
                        width: "99%",
                        position: "relative",
                        height: "15%",
                        backgroundColor: "#f39406",
                        marginLeft: "0.5%",
                        borderBottomLeftRadius: "5vh",
                        borderBottomRightRadius: "5vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around", // Alinea los elementos a ambos extremos y el centro
                        padding: "0 20px", // Añade un poco de padding a los lados para evitar que los elementos toquen los bordes
                    }}>

                    {/* Texto de contacto alineado a la izquierda */}
                    <div style={{ width: 'auto', display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%' }}>
                        <Text style={{ fontSize: 14, paddingRight: 3 }}>Contacter ventes:</Text><Text style={{ fontSize: 14, color: "blue", cursor: "pointer", textDecoration: "underline" }}>ventes@gocareerswipe.com</Text>
                    </div>

                    {/* Texto central */}
                    <div style={{ width: '45%', display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%' }}>
                        <Text onClick={() => window.open('https://gocareerswipe.com/', '_blank')} style={{ fontSize: "4vh", color: "blue", cursor: "pointer", textDecoration: "underline" }}>gocareerswipe.com</Text>

                    </div>

                    {/* Contenedor para las imágenes, alineado a la derecha */}
                    <div style={{ width: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <img onClick={(e) => {
                            e.stopPropagation(); // Previene que el click en la imagen abra también gocareerswipe.com
                            window.open('https://www.youtube.com/watch?v=vWZ_ME5YrwQ&ab_channel=CareerSwipe', '_blank');
                        }}
                            style={{ height: "4vh" }} src={iconYoutube} alt="YouTube" />
                        <img onClick={(e) => {
                            e.stopPropagation(); // Previene que el click en la imagen abra también gocareerswipe.com
                            window.open('https://www.linkedin.com/company/services-career-swipe/?viewAsMember=true', '_blank');
                        }}
                            style={{ height: "4vh", marginLeft: 10 }} src={iconLinkeding} alt="LinkedIn" />
                    </div>
                </div>

                <div onClick={() => window.open('https://calendly.com/irgt2023/servicecareerswipe', '_blank')} style={{ width: "10vw", cursor: "pointer", backgroundColor: "#2b8a0c", justifyContent: "center", alignItems: "center", textAlign: "center", paddingTop: "1vh", paddingBottom: "1vh", position: "absolute", right: "-9.6vw", borderTopRightRadius: "2vh", borderBottomRightRadius: "2vh", top: "57vh", border: "0.2vh solid #747473 ", flexDirection: "column", display: "flex" }}>
                    <Text style={{ fontSize: "2vh", fontWeight: "bold", color: "white" }}>Demandez</Text>
                    <Text style={{ fontSize: "2vh", fontWeight: "bold", color: "white", marginTop: "-0.5vh" }}>une démo</Text>
                </div>

            </div>
        </div>
    )
}

export default PlansViewFR
